import { IcebergAlert, IcebergAlertVariant } from '@tradesolution/iceberg-ui-react';

interface Props {
  text?: string;
}

const ErrorFeedback = (props: Props) => {
  if (!props.text) return null;
  return (
    <div className="mt-3">
      <IcebergAlert variant={IcebergAlertVariant.Danger} body={props.text} />
    </div>
  );
};

export default ErrorFeedback;
